import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
//validators
import {validateField} from '../common/redux/validators';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

class CompletionDialog extends React.Component {
  state = {
    buttonDisabled:false
  };

  constructor(props)
  {
    super(props);
    //bindings
    this.changeStatus = this.changeStatus.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onEnter = this.onEnter.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  changeStatus()
  {
     if (!validateField(this.state.completion_date)) 
      {
        this.setState({completion_date_error: 'Please enter the required fields'});
        return;
      }
      this.setState({buttonDisabled:true});
      //Vamos a editar/crear Componen
      this.props.actions.changeRpStatus(this.props.w_table, this.props.reporting_period, this.state.completion_date,this.props.action, this.props.project)
      .then(res=>{
        this.handleClose();
      });
  }
  
  handleClose()
  {
    this.props.handleClose();
  }

  onEnter()
  {
    this.setState({completion_date:'', completion_date_error:'',buttonDisabled:false});
  }

  
  handleChange(event) 
  {
    const target = event.target;
    const value = target.value;
    let completion_date = value;
    this.setState({completion_date:completion_date});
  }
  
  render() {
    return (
      <div>
        <Dialog
          open={this.props.open}
          onClose={this.props.handleClose}
          onEnter={this.onEnter}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Update Reporting Period</DialogTitle>
          <DialogContent>
           <TextField
              style={{width: '90%'}}
              id="completion_date"
              label="Completion Date"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              onChange={this.handleChange}
              value={this.state.completion_date}
              error={this.state.completion_date_error}
              helperText={this.state.completion_date_error}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.changeStatus} color="primary"  disabled={this.state.buttonDisabled}>
              Update
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    periods: state.periods,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)((CompletionDialog));


// WEBPACK FOOTER //
// ./src/features/periods/CompletionDialog.js